import { render, staticRenderFns } from "./edicao_usuario_prefeitura.vue?vue&type=template&id=65097b34&scoped=true"
import script from "./edicao_usuario_prefeitura.vue?vue&type=script&lang=js"
export * from "./edicao_usuario_prefeitura.vue?vue&type=script&lang=js"
import style0 from "./edicao_usuario_prefeitura.vue?vue&type=style&index=0&id=65097b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65097b34",
  null
  
)

export default component.exports